<mat-card *ngIf="!newUser">
  <mat-card-header>
    <!-- <mat-card-title> -->
    <div class="flex flex-row w-4/12">
      <span style="font-size: x-large;">
        Action Items
      </span>
      <a href="/assets/WEMSUserManual.pdf" target="_blank" >

          <mat-icon class="dark-theme-icon" inline="true">help_outline</mat-icon>
      </a>

    </div>
    <div class="flex flex-row w-6/12">
      <mat-form-field style="height: 60px;">
        <!-- <mat-label>County</mat-label> -->
        <mat-select [(ngModel)]="countySelected" (selectionChange)="countyChange($event.value)">
          <mat-option *ngIf="isAdmin" value="All">ALL</mat-option>
          <mat-option *ngFor="let list of countyList" [value]="list.value">
            {{list.text}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="flex flex-row w-4/12">
      <span style="font-size: x-large;">
      </span>
      <a (click)="showExemptBusinesses()">
        [Exempt Businesses]
      </a>

    </div>
    <!-- </mat-card-title> -->
  </mat-card-header>
  <mat-card-content>
    <div class="flex flex-row items-center w-full">
      <div class="flex flex-col w-11/12">

        <!-- Unverified Complaints -->

        <button mat-raised-button (click)="unverified(countySelected)" class="m-8 w-full" style="background: #7ABDF3;">
          <mat-icon *ngIf="unverifiedCount" style="color: red;">warning</mat-icon>
          Unverified Complaint ({{unverifiedCount}})
        </button>
        <div *ngIf="actionItems == 'unverified'" class="w-full m-8 flex flex-col w-full">
          <span class="text-muted" style="font-size: small;">Complaints not matched with Business (verify within 5 business days of the Complaint
            Date).<br /><br /></span>
          <app-mainMenu-unverifiedComplaint [countyId]="countySelected"
            class="w-full m-8"></app-mainMenu-unverifiedComplaint>
        </div>

        <!-- Complainant Reponse Letters Due -->

        <button mat-raised-button (click)="complaintResponse(countySelected)" class="m-8 w-full"
          style="background: #6EB7F2;">
          <mat-icon *ngIf="complaintResponseCount" style="color: red;">warning</mat-icon>
          Complaint Response Letters Due ({{complaintResponseCount}})
        </button>
        <div *ngIf="actionItems == 'complaintResponse'" class="w-full m-8 flex flex-col w-full">
          <span class="text-muted" style="font-size: small;">Complainant Response Letters Due (Send within 10 business days of the Complaint
            Date). Letters that have not been sent will remain in action items.<br />
            Reminder: Complainant letters must be sent for any ICAA related complaint - both valid and not-valid.
          </span>
          <app-mainMenu-complaintResponse [countyId]="countySelected"
            class="w-full m-8"></app-mainMenu-complaintResponse>
          <!-- <complaintDetails></complaintDetails> -->
        </div>

        <button mat-raised-button (click)="businessResponse(countySelected)" class="m-8 w-full"
          style="background: #62B1F1;">
          <mat-icon *ngIf="businessResponseCount" style="color: red;">warning</mat-icon> Initial Business Response
          Letters Due ({{businessResponseCount}})
        </button>
        <div *ngIf="actionItems == 'businessResponse'" class="w-full m-8 flex flex-col w-full">
          <span class="text-muted" style="font-size: small;">Initial Response Letters Due (Send within 10 business days of the Complaint Date).
            Letters that have not been sent will remain in action items.</span>
          <app-mainMenu-businessResponse [countyId]="countySelected" class="w-full m-8"></app-mainMenu-businessResponse>
        </div>

        <button mat-raised-button (click)="siteVisit(countySelected)" class="m-8 w-full" style="background: #56ABF0;">
          <mat-icon *ngIf="siteVisitCount" style="color: red;">warning</mat-icon>
          Initial Site Visit Due ({{siteVisitCount}})
        </button>
        <div *ngIf="actionItems == 'siteVisit'" class="w-full m-8 flex flex-col w-full">
          <span class="text-muted" style="font-size: small;">Initial Site Visits Due (Complete within 30 days of the Complaint Date).</span>
          <app-mainMenu-siteVisit [countyId]="countySelected" class="w-full m-8"></app-mainMenu-siteVisit>
        </div>

        <button mat-raised-button (click)="followupVisit(countySelected)" class="m-8 w-full"
          style="background: #4AA5EF;">
          <mat-icon *ngIf="followupVisitCount" style="color: red;">warning</mat-icon> Follow-up Visits Due
          ({{followupVisitCount}})
        </button>
        <div *ngIf="actionItems == 'followupVisit'" class="w-full m-8 flex flex-col w-full">
          <span class="text-muted" style="font-size: small;">Follow-up Visits due (complete within 30 days of the remediation plan due
            date).</span>
          <app-mainMenu-followupVisit [countyId]="countySelected" class="w-full m-8"></app-mainMenu-followupVisit>
        </div>

        <button mat-raised-button (click)="postRemediation(countySelected)" class="m-8 w-full"
          style="background: #3E9FEE;">
          <mat-icon *ngIf="postRemediationCount" style="color: red;">warning</mat-icon> Post Remediation Plan Visits Due
          ({{postRemediationCount}})
        </button>
        <div *ngIf="actionItems == 'postRemediation'" class="w-full m-8 flex flex-col w-full">
          <span class="text-muted" style="font-size: small;">Post Remediation Plan Visits Due. (Complete within 21 days of Complaint Date).</span>
          <app-mainMenu-postRemediation [countyId]="countySelected" class="w-full m-8"></app-mainMenu-postRemediation>
        </div>

        <button mat-raised-button (click)="citations(countySelected)" class="m-8 w-full" style="background: #3299ED;">
          <mat-icon *ngIf="citationsCount" style="color: red;">warning</mat-icon> Citations ({{citationsCount}})
        </button>
        <div *ngIf="actionItems == 'citations'" class="w-full m-8 flex flex-col w-full">
          <app-mainMenu-citations [countyId]="countySelected" class="w-full m-8"></app-mainMenu-citations>
        </div>

        <button mat-raised-button (click)="annualInspections(countySelected)" class="m-8 w-full"
          style="background: #2693EC;">
          <mat-icon *ngIf="annualInspectionsCount" style="color: red;">warning</mat-icon> Annual Inspections Due
          ({{annualInspectionsCount}})
        </button>
        <div *ngIf="actionItems == 'annualInspections'" class="w-full m-8 flex flex-col w-full">
          <span class="text-muted" style="font-size: small;">Complete annual inspections by June 30 each year.</span>
          <app-mainMenu-annualInspections [countyId]="countySelected"
            class="w-full m-8"></app-mainMenu-annualInspections>
        </div>

        <button mat-raised-button (click)="businessEnclosed(countySelected)" class="m-8 w-full"
          style="background: #1A8DEB;">
          Businesses with Enclosed Areas
          ({{businessEnclosedCount}})
        </button>
        <div *ngIf="actionItems == 'businessEnclosed'" class="w-full m-8 flex flex-col w-full">
          <app-mainMenu-enclosedAreas [countyId]="countySelected" class="w-full m-8"></app-mainMenu-enclosedAreas>
        </div>

      </div>
    </div>


  </mat-card-content>
</mat-card>

<div *ngIf="newUser">
  <h1>Please contact administrator to activate your account.</h1>
</div>

<!-- <img src="../../../assets/images/translucentOhaLogo.png" class="bg hideOnMobile" alt="Oregon Health Authority Logo"
  aria-label="Oregon Health Authority Logo">

<img src="../../../assets/images/translucentOhaLogo.png" class="bg-mobile showOnMobile"
  alt="Oregon Health Authority Logo" aria-label="Oregon Health Authority Logo"> -->

<div *ngIf="!loggingIn" class="flex flex-col sm:justify-start sm:items-center gap-4">
  <!-- B2C Login options -->
  <div class="flex flex-col md:flex-row gap-6 sm:gap-40">

    <div class="flex flex-col gap-2 justify-start items-center">
      <!-- <span style="font-size: x-large;"> <strong>WEMS Login</strong> </span> -->
      <!-- <span style="font-size: x-large;"> <strong>Login / Register New Account</strong> </span> -->
      <!-- <button mat-raised-button (click)="login()" color="primary">Login</button> -->
    </div>

  </div>

</div>


<div *ngIf="loggingIn">
  <div id="globalLoader" class="global-loader">
    <h1>Loading...</h1>
  </div>
</div>